import * as React from "react";
import { Link } from "gatsby";

// Components
import { Layout, Metatags, CTASection } from "../../components";

const BLOGS_PER_LOAD = 6;

const Index = ({ serverData }) => {
  const blogsData = serverData?.blogs || [];
  const [visibleBlogs, setVisibleBlogs] = React.useState(BLOGS_PER_LOAD);

  const handleShowMore = React.useCallback(() => {
    setVisibleBlogs((prevVisible) => prevVisible + BLOGS_PER_LOAD);
  }, []);

  const renderSkeleton = () => (
    <>
      {Array.from({ length: BLOGS_PER_LOAD }).map((_, index) => (
        <div className="col-lg-12 mb-5" key={index}>
          <div
            className="rounded d-flex align-items-end skeleton"
            style={{ height: "350px" }}
          ></div>
        </div>
      ))}
    </>
  );

  const renderBlogItem = React.useCallback(
    (blog) => (
      <Link
        className="col-lg-12 mb-5 text-decoration-none"
        to={`/blog/${blog?.slug}/`}
        key={blog.id}
      >
        <div className="blog_item row rounded">
          <div className="col-lg-5 p-0">
            <img
              className="rounded object-fit-cover w-100 h-100 img-fluid"
              src={
                blog.media?.media_details?.sizes?.medium_large?.source_url ||
                blog?.jetpack_featured_media_url
              }
              alt={blog?.title.rendered}
            />
          </div>
          <div className="col-lg-7 p-3">
            <h2 className="text-black fs-2 fw-bold py-2">
              {blog?.title.rendered}
            </h2>
            <p
              className="text-black fs-4 py-2"
              dangerouslySetInnerHTML={{
                __html: blog?.excerpt.rendered,
              }}
            />
          </div>
        </div>
      </Link>
    ),
    []
  );

  return (
    <Layout>
      <div className="bg-white mt-10">
        <div className="container pb-10">
          <div className="py-md-5 small-container">
            <h1 className="text-dark fs-1 fw-bold">
              Some Articles For Developers
            </h1>
            <p className="text-dark py-3 fs-3">
              Here are some articles that I have written for developers. I hope
              you find them helpful. If you have any questions or feedback,
              please feel free to reach out to me.
            </p>
          </div>

          <div className="row mt-5">
            {blogsData.length === 0
              ? renderSkeleton()
              : blogsData.slice(0, visibleBlogs).map(renderBlogItem)}
          </div>

          {visibleBlogs < blogsData.length && (
            <div className="text-center mt-4">
              <button
                onClick={handleShowMore}
                className="btn btn-primary btn-lg"
              >
                Show More
              </button>
            </div>
          )}
        </div>
      </div>

      <CTASection />
    </Layout>
  );
};

export default Index;

export const Head = () => <Metatags title="Blogs | Hanzala" />;

export async function getServerData() {
  try {
    const blogResponse = await fetch(
      `${process.env.GATSBY_BLOGS_API_URL}/index.php/wp-json/wp/v2/posts?per_page=100`
    );

    if (!blogResponse.ok) {
      throw new Error(`Failed to fetch blogs, Status: ${blogResponse.status}`);
    }

    const blogs = await blogResponse.json();

    // Directly use `jetpack_featured_media_url`
    const formattedBlogs = blogs.map((blog) => ({
      ...blog,
      mediaUrl: blog.jetpack_featured_media_url || null, // Ensure no missing images
    }));

    return {
      props: {
        blogs: formattedBlogs,
      },
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      status: 500,
      props: {
        blogs: [],
      },
    };
  }
}
